/* RESPONSIBLE TEAM: team-rd-services */
import Model, { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';

import { post } from 'embercom/lib/ajax';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { IntegrationState } from 'embercom/objects/standalone/constants';

export default class LivePersonConfiguration extends Model {
  @service declare finStandaloneService: FinStandaloneService;

  @attr('string') declare username: string;
  @attr('string') declare appKey: string;
  @attr('string') declare secret: string;
  @attr('string') declare accessToken: string;
  @attr('string') declare accessTokenSecret: string;
  @attr('string') declare accountId: string;
  @attr('string') declare tokenId: string | null;
  @attr('string') declare escalationSkill: string;
  @attr('boolean') declare disableJwtVerification: boolean;
  @attr('boolean') declare configured: boolean;

  get integrationState() {
    if (
      this.configured &&
      this.username &&
      this.appKey &&
      this.secret &&
      this.accessToken &&
      this.accessTokenSecret &&
      this.accountId
    ) {
      return IntegrationState.Enabled;
    } else {
      return IntegrationState.NotConfigured;
    }
  }

  get canUpdateAPISettings() {
    return true;
  }

  get isPendingSetup() {
    return !this.configured;
  }

  get isFormValid() {
    return !!(
      this.username &&
      this.appKey &&
      this.secret &&
      this.accessToken &&
      this.accessTokenSecret &&
      this.accountId
    );
  }

  async revoke() {
    await post(`/ember/standalone/live_person_configurations/${this.id}/revoke`);
    this.username = '';
    this.appKey = '';
    this.secret = '';
    this.accessToken = '';
    this.accessTokenSecret = '';
    this.accountId = '';
    this.tokenId = '';
    this.escalationSkill = '';
    this.disableJwtVerification = false;
    this.configured = false;
    await this.reload();
  }
}
